import { IBusDangKyXeSaveRequest } from '../../../models/request/bus/busDangKyXeSaveRequest';
import { IBusTuyenDuongSelectRequest } from '../../../models/request/bus/busBaoCaoDiemDanhRequest';
import { IUploadExcelRequest } from '../../../models/request/bus/uploadExcelRequest';
import { BusDangKyXeItemResponse } from '../../../models/response/bus/bus_dangkyxe';
import { BusDiemDonTraItemResponse } from '../../../models/response/bus/bus_diemdontra';
import { bus_hinhthuc_dangky } from '../../../models/response/bus/bus_hinhthuc_dangky';
import { bus_hinhthuc_dontra } from '../../../models/response/bus/bus_hinhthuc_dontra';
import { bus_loaidiemdon } from '../../../models/response/bus/bus_loaidiemdon';
import { bus_trangthai_dangky } from '../../../models/response/bus/bus_trangthai_dangky';
import { BusTuyenDuongItemResponse } from '../../../models/response/bus/bus_tuyenduong';
import { BusTuyenDuongChiTietItemResponse } from '../../../models/response/bus/bus_tuyenduong_chitiet';

/** Request lấy điểm đón trả theo tuyến đường / loại điểm đón (giống logic cmb_bus_diemdontra của adm) */
export interface IBusDangKyXeSelectDiemDonTraRequest {
	dm_coso_id: number;
	bus_tuyenduong_id: number;
	bus_loaidiemdon_id: number;
}

export enum eBusDangKyXeActionTypeIds {
	LOAD_START = "BUS_DANGKYXE_LOAD_START",
	LOAD_SUCCESS = "BUS_DANGKYXE_LOAD_SUCCESS",
	LOAD_ERROR = "BUS_DANGKYXE_LOAD_ERROR",

	LOAD_DETAIL_START = "BUS_DANGKYXE_LOAD_DETAIL_START",
	LOAD_DETAIL_SUCCESS = "BUS_DANGKYXE_LOAD_DETAIL_SUCCESS",
	LOAD_DETAIL_ERROR = "BUS_DANGKYXE_LOAD_DETAIL_ERROR",

	LOAD_HINHTHUC_DONTRA_START = "BUS_DANGKYXE_LOAD_HINHTHUC_DONTRA_START",
	LOAD_HINHTHUC_DONTRA_SUCCESS = "BUS_DANGKYXE_LOAD_HINHTHUC_DONTRA_SUCCESS",
	LOAD_HINHTHUC_DONTRA_ERROR = "BUS_DANGKYXE_LOAD_HINHTHUC_DONTRA_ERROR",

	LOAD_HINHTHUC_DANGKY_START = "BUS_DANGKYXE_LOAD_HINHTHUC_DANGKY_START",
	LOAD_HINHTHUC_DANGKY_SUCCESS = "BUS_DANGKYXE_LOAD_HINHTHUC_DANGKY_SUCCESS",
	LOAD_HINHTHUC_DANGKY_ERROR = "BUS_DANGKYXE_LOAD_HINHTHUC_DANGKY_ERROR",

	LOAD_LOAIDIEMDON_START = "BUS_DANGKYXE_LOAD_LOAIDIEMDON_START",
	LOAD_LOAIDIEMDON_SUCCESS = "BUS_DANGKYXE_LOAD_LOAIDIEMDON_SUCCESS",
	LOAD_LOAIDIEMDON_ERROR = "BUS_DANGKYXE_LOAD_LOAIDIEMDON_ERROR",

	LOAD_TRANGTHAI_DANGKY_START = "BUS_DANGKYXE_LOAD_TRANGTHAI_DANGKY_START",
	LOAD_TRANGTHAI_DANGKY_SUCCESS = "BUS_DANGKYXE_LOAD_TRANGTHAI_DANGKY_SUCCESS",
	LOAD_TRANGTHAI_DANGKY_ERROR = "BUS_DANGKYXE_LOAD_TRANGTHAI_DANGKY_ERROR",

	LOAD_TUYENDUONG_START = "BUS_DANGKYXE_LOAD_TUYENDUONG_START",
	LOAD_TUYENDUONG_SUCCESS = "BUS_DANGKYXE_LOAD_TUYENDUONG_SUCCESS",
	LOAD_TUYENDUONG_ERROR = "BUS_DANGKYXE_LOAD_TUYENDUONG_ERROR",

	LOAD_DIEMDONTRA_START = "BUS_DANGKYXE_LOAD_DIEMDONTRA_START",
	LOAD_DIEMDONTRA_SUCCESS = "BUS_DANGKYXE_LOAD_DIEMDONTRA_SUCCESS",
	LOAD_DIEMDONTRA_ERROR = "BUS_DANGKYXE_LOAD_DIEMDONTRA_ERROR",

	LOAD_TUYENDUONG_CHITIET_START = "BUS_DANGKYXE_LOAD_TUYENDUONG_CHITIET_START",
	LOAD_TUYENDUONG_CHITIET_SUCCESS = "BUS_DANGKYXE_LOAD_TUYENDUONG_CHITIET_SUCCESS",
	LOAD_TUYENDUONG_CHITIET_ERROR = "BUS_DANGKYXE_LOAD_TUYENDUONG_CHITIET_ERROR",

	SHOW_DETAIL = "BUS_DANGKYXE_SHOW_DETAIL",
	CLOSE_DETAIL = "BUS_DANGKYXE_CLOSE_DETAIL",

	SHOW_TUYENDUONG_CHITIET_MODAL = "BUS_DANGKYXE_SHOW_TUYENDUONG_CHITIET_MODAL",
	CLOSE_TUYENDUONG_CHITIET_MODAL = "BUS_DANGKYXE_CLOSE_TUYENDUONG_CHITIET_MODAL",

	CHANGE_SELECTED_IDS = "BUS_DANGKYXE_CHANGE_SELECTED_IDS",
	CHANGE_FILTER_TRANGTHAI = "BUS_DANGKYXE_CHANGE_FILTER_TRANGTHAI",

	SHOW_CONFIRM = "BUS_DANGKYXE_SHOW_CONFIRM",
	CLOSE_CONFIRM = "BUS_DANGKYXE_CLOSE_CONFIRM",

	SAVE_START = "BUS_DANGKYXE_SAVE_START",
	SAVE_SUCCESS = "BUS_DANGKYXE_SAVE_SUCCESS",
	SAVE_ERROR = "BUS_DANGKYXE_SAVE_ERROR",

	DELETE_START = "BUS_DANGKYXE_DELETE_START",
	DELETE_SUCCESS = "BUS_DANGKYXE_DELETE_SUCCESS",
	DELETE_ERROR = "BUS_DANGKYXE_DELETE_ERROR",

	SHOW_IMPORT_MODAL = "BUS_DANGKYXE_SHOW_IMPORT_MODAL",
	CLOSE_IMPORT_MODAL = "BUS_DANGKYXE_CLOSE_IMPORT_MODAL",

	VALIDATE_IMPORT_START = "BUS_DANGKYXE_VALIDATE_IMPORT_START",
	VALIDATE_IMPORT_SUCCESS = "BUS_DANGKYXE_VALIDATE_IMPORT_SUCCESS",
	VALIDATE_IMPORT_ERROR = "BUS_DANGKYXE_VALIDATE_IMPORT_ERROR",

	IMPORT_START = "BUS_DANGKYXE_IMPORT_START",
	IMPORT_SUCCESS = "BUS_DANGKYXE_IMPORT_SUCCESS",
	IMPORT_ERROR = "BUS_DANGKYXE_IMPORT_ERROR"
}

export interface IBusDangKyXeLoadStart {
	type: eBusDangKyXeActionTypeIds.LOAD_START,
	payload: IBusTuyenDuongSelectRequest
}
export interface IBusDangKyXeLoadSuccess {
	type: eBusDangKyXeActionTypeIds.LOAD_SUCCESS,
	payload: BusDangKyXeItemResponse[]
}
export interface IBusDangKyXeLoadErr {
	type: eBusDangKyXeActionTypeIds.LOAD_ERROR,
	payload: string
}
export interface IBusDangKyXeLoadDetailStart {
	type: eBusDangKyXeActionTypeIds.LOAD_DETAIL_START,
	payload: number
}
export interface IBusDangKyXeLoadDetailSuccess {
	type: eBusDangKyXeActionTypeIds.LOAD_DETAIL_SUCCESS,
	payload: BusDangKyXeItemResponse
}
export interface IBusDangKyXeLoadDetailErr {
	type: eBusDangKyXeActionTypeIds.LOAD_DETAIL_ERROR,
	payload: string
}
export interface IBusHinhThucDonTraLoadStart {
	type: eBusDangKyXeActionTypeIds.LOAD_HINHTHUC_DONTRA_START
}
export interface IBusHinhThucDonTraLoadSuccess {
	type: eBusDangKyXeActionTypeIds.LOAD_HINHTHUC_DONTRA_SUCCESS,
	payload: bus_hinhthuc_dontra[]
}
export interface IBusHinhThucDonTraLoadErr {
	type: eBusDangKyXeActionTypeIds.LOAD_HINHTHUC_DONTRA_ERROR,
	payload: string
}
export interface IBusHinhThucDangKyLoadStart {
	type: eBusDangKyXeActionTypeIds.LOAD_HINHTHUC_DANGKY_START
}
export interface IBusHinhThucDangKyLoadSuccess {
	type: eBusDangKyXeActionTypeIds.LOAD_HINHTHUC_DANGKY_SUCCESS,
	payload: bus_hinhthuc_dangky[]
}
export interface IBusHinhThucDangKyLoadErr {
	type: eBusDangKyXeActionTypeIds.LOAD_HINHTHUC_DANGKY_ERROR,
	payload: string
}
export interface IBusLoaiDiemDonLoadStart {
	type: eBusDangKyXeActionTypeIds.LOAD_LOAIDIEMDON_START
}
export interface IBusLoaiDiemDonLoadSuccess {
	type: eBusDangKyXeActionTypeIds.LOAD_LOAIDIEMDON_SUCCESS,
	payload: bus_loaidiemdon[]
}
export interface IBusLoaiDiemDonLoadErr {
	type: eBusDangKyXeActionTypeIds.LOAD_LOAIDIEMDON_ERROR,
	payload: string
}
export interface IBusTrangThaiDangKyLoadStart {
	type: eBusDangKyXeActionTypeIds.LOAD_TRANGTHAI_DANGKY_START
}
export interface IBusTrangThaiDangKyLoadSuccess {
	type: eBusDangKyXeActionTypeIds.LOAD_TRANGTHAI_DANGKY_SUCCESS,
	payload: bus_trangthai_dangky[]
}
export interface IBusTrangThaiDangKyLoadErr {
	type: eBusDangKyXeActionTypeIds.LOAD_TRANGTHAI_DANGKY_ERROR,
	payload: string
}
export interface IBusDangKyXeTuyenDuongLoadStart {
	type: eBusDangKyXeActionTypeIds.LOAD_TUYENDUONG_START,
	payload: IBusTuyenDuongSelectRequest
}
export interface IBusDangKyXeTuyenDuongLoadSuccess {
	type: eBusDangKyXeActionTypeIds.LOAD_TUYENDUONG_SUCCESS,
	payload: BusTuyenDuongItemResponse[]
}
export interface IBusDangKyXeTuyenDuongLoadErr {
	type: eBusDangKyXeActionTypeIds.LOAD_TUYENDUONG_ERROR,
	payload: string
}
export interface IBusDangKyXeDiemDonTraLoadStart {
	type: eBusDangKyXeActionTypeIds.LOAD_DIEMDONTRA_START,
	payload: IBusDangKyXeSelectDiemDonTraRequest
}
export interface IBusDangKyXeDiemDonTraLoadSuccess {
	type: eBusDangKyXeActionTypeIds.LOAD_DIEMDONTRA_SUCCESS,
	payload: BusDiemDonTraItemResponse[]
}
export interface IBusDangKyXeDiemDonTraLoadErr {
	type: eBusDangKyXeActionTypeIds.LOAD_DIEMDONTRA_ERROR,
	payload: string
}
export interface IBusDangKyXeTuyenDuongChiTietLoadStart {
	type: eBusDangKyXeActionTypeIds.LOAD_TUYENDUONG_CHITIET_START,
	payload: number
}
export interface IBusDangKyXeTuyenDuongChiTietLoadSuccess {
	type: eBusDangKyXeActionTypeIds.LOAD_TUYENDUONG_CHITIET_SUCCESS,
	payload: BusTuyenDuongChiTietItemResponse[]
}
export interface IBusDangKyXeTuyenDuongChiTietLoadErr {
	type: eBusDangKyXeActionTypeIds.LOAD_TUYENDUONG_CHITIET_ERROR,
	payload: string
}
export interface IBusDangKyXeShowDetail {
	type: eBusDangKyXeActionTypeIds.SHOW_DETAIL,
	payload?: BusDangKyXeItemResponse
}
export interface IBusDangKyXeCloseDetail {
	type: eBusDangKyXeActionTypeIds.CLOSE_DETAIL
}
export interface IBusDangKyXeShowTuyenDuongChiTietModal {
	type: eBusDangKyXeActionTypeIds.SHOW_TUYENDUONG_CHITIET_MODAL,
	payload: number
}
export interface IBusDangKyXeCloseTuyenDuongChiTietModal {
	type: eBusDangKyXeActionTypeIds.CLOSE_TUYENDUONG_CHITIET_MODAL
}
export interface IBusDangKyXeChangeSelectedIds {
	type: eBusDangKyXeActionTypeIds.CHANGE_SELECTED_IDS,
	payload: number[]
}
export interface IBusDangKyXeChangeFilterTrangThai {
	type: eBusDangKyXeActionTypeIds.CHANGE_FILTER_TRANGTHAI,
	payload: number
}
export interface IBusDangKyXeShowConfirm {
	type: eBusDangKyXeActionTypeIds.SHOW_CONFIRM
}
export interface IBusDangKyXeCloseConfirm {
	type: eBusDangKyXeActionTypeIds.CLOSE_CONFIRM
}
export interface IBusDangKyXeSaveStart {
	type: eBusDangKyXeActionTypeIds.SAVE_START,
	payload: IBusDangKyXeSaveRequest
}
export interface IBusDangKyXeSaveSuccess {
	type: eBusDangKyXeActionTypeIds.SAVE_SUCCESS,
	payload: boolean
}
export interface IBusDangKyXeSaveErr {
	type: eBusDangKyXeActionTypeIds.SAVE_ERROR,
	payload: string
}
export interface IBusDangKyXeDeleteStart {
	type: eBusDangKyXeActionTypeIds.DELETE_START,
	payload: number
}
export interface IBusDangKyXeDeleteSuccess {
	type: eBusDangKyXeActionTypeIds.DELETE_SUCCESS
}
export interface IBusDangKyXeDeleteErr {
	type: eBusDangKyXeActionTypeIds.DELETE_ERROR,
	payload: string
}
export interface IBusDangKyXeShowImportModal {
	type: eBusDangKyXeActionTypeIds.SHOW_IMPORT_MODAL
}
export interface IBusDangKyXeCloseImportModal {
	type: eBusDangKyXeActionTypeIds.CLOSE_IMPORT_MODAL
}
export interface IBusDangKyXeValidateImportStart {
	type: eBusDangKyXeActionTypeIds.VALIDATE_IMPORT_START,
	payload: IUploadExcelRequest
}
export interface IBusDangKyXeValidateImportSuccess {
	type: eBusDangKyXeActionTypeIds.VALIDATE_IMPORT_SUCCESS,
	payload: any[]
}
export interface IBusDangKyXeValidateImportErr {
	type: eBusDangKyXeActionTypeIds.VALIDATE_IMPORT_ERROR,
	payload: string
}
export interface IBusDangKyXeImportStart {
	type: eBusDangKyXeActionTypeIds.IMPORT_START,
	payload: IUploadExcelRequest
}
export interface IBusDangKyXeImportSuccess {
	type: eBusDangKyXeActionTypeIds.IMPORT_SUCCESS
}
export interface IBusDangKyXeImportErr {
	type: eBusDangKyXeActionTypeIds.IMPORT_ERROR,
	payload: string
}

export type IBusDangKyXeActionTypes = IBusDangKyXeLoadStart | IBusDangKyXeLoadSuccess | IBusDangKyXeLoadErr |
	IBusDangKyXeLoadDetailStart | IBusDangKyXeLoadDetailSuccess | IBusDangKyXeLoadDetailErr |
	IBusHinhThucDonTraLoadStart | IBusHinhThucDonTraLoadSuccess | IBusHinhThucDonTraLoadErr |
	IBusHinhThucDangKyLoadStart | IBusHinhThucDangKyLoadSuccess | IBusHinhThucDangKyLoadErr |
	IBusLoaiDiemDonLoadStart | IBusLoaiDiemDonLoadSuccess | IBusLoaiDiemDonLoadErr |
	IBusTrangThaiDangKyLoadStart | IBusTrangThaiDangKyLoadSuccess | IBusTrangThaiDangKyLoadErr |
	IBusDangKyXeTuyenDuongLoadStart | IBusDangKyXeTuyenDuongLoadSuccess | IBusDangKyXeTuyenDuongLoadErr |
	IBusDangKyXeDiemDonTraLoadStart | IBusDangKyXeDiemDonTraLoadSuccess | IBusDangKyXeDiemDonTraLoadErr |
	IBusDangKyXeTuyenDuongChiTietLoadStart | IBusDangKyXeTuyenDuongChiTietLoadSuccess | IBusDangKyXeTuyenDuongChiTietLoadErr |
	IBusDangKyXeShowDetail | IBusDangKyXeCloseDetail |
	IBusDangKyXeShowTuyenDuongChiTietModal | IBusDangKyXeCloseTuyenDuongChiTietModal |
	IBusDangKyXeChangeSelectedIds | IBusDangKyXeChangeFilterTrangThai |
	IBusDangKyXeShowConfirm | IBusDangKyXeCloseConfirm |
	IBusDangKyXeSaveStart | IBusDangKyXeSaveSuccess | IBusDangKyXeSaveErr |
	IBusDangKyXeDeleteStart | IBusDangKyXeDeleteSuccess | IBusDangKyXeDeleteErr |
	IBusDangKyXeShowImportModal | IBusDangKyXeCloseImportModal |
	IBusDangKyXeValidateImportStart | IBusDangKyXeValidateImportSuccess | IBusDangKyXeValidateImportErr |
	IBusDangKyXeImportStart | IBusDangKyXeImportSuccess | IBusDangKyXeImportErr
